import { Link } from "react-router-dom";
import { usePagedList } from "@/lib/api";
import { Container, LoadingGrid, PageHeader } from "@/components/site/PageHeader";
import { LoadMore, SearchBox } from "@/components/site/ListControls";

export default function Artists() {
  const list = usePagedList("/artists", {}, 48);
  const data = list.items;
  const isLoading = list.isLoading;
  return (
    <>
      <PageHeader top="Artistes" bottom="& soutiens" intro="Leur route a croisé celle de LGTDZ : leurs événements, mixes et contributions." testId="artists-header" />
      <Container className="pt-12">
        <SearchBox value={list.q} onChange={list.setQ} placeholder="Rechercher un artiste…" testId="artists-search" />
      </Container>
      <Container className="py-16">
        {isLoading ? (
          <LoadingGrid />
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12" data-testid="artists-grid">
            {data.map((a, i) => (
              <Link key={a.id} to={`/artistes/${a.slug}`} className="group block reveal" style={{ animationDelay: `${(i % 8) * 60}ms` }} data-testid={`artist-card-${a.id}`}>
                <div className="overflow-hidden aspect-[4/5] bg-[hsl(var(--surface))]">
                  {a.image && <img src={a.image} alt={a.name} loading="lazy" className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700" />}
                </div>
                <h3 className="font-display uppercase text-2xl lg:text-3xl mt-4 text-white group-hover:text-primary transition-colors leading-none">{a.name}</h3>
                {a.tags?.length > 0 && <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mt-2">{a.tags.join(" · ")}</p>}
              </Link>
            ))}
          </div>
        )}
        <LoadMore list={list} testId="artists-load-more" />
      </Container>
    </>
  );
}
